import React, { useContext } from "react";
import styles from "./styles.module.css";
import receipt_bottom from "./../../../../assets/images/receipt_bottom_pattern.png";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { LanguageContext } from "../../../../context/LanguageContext";
import { ParagraphText } from "../../../../Libraries";
import useOrderSummary from "../../../../hooks/useOrderSummary";

const Receipt = React.forwardRef(({ orders = [], transaction }, ref) => {
  transaction = transaction.length ? transaction[0] : transaction;
  const [I18n] = useContext(LanguageContext);

  const { subTotalAmount, totalAmount, totalDiscountPerItem } = useOrderSummary(
    {
      sale_order_line: orders,
      orderDiscount: transaction?._raw?.discount,
      orderDiscountMethod: transaction?._raw?.discount_unit,
      orderTax: transaction?._raw?.tax,
      orderTaxMethod: transaction?._raw?.tax_type,
    },
  );

  return (
    <div ref={ref} className={styles["receipt-container"]}>
      <div className={styles["receipt-inner"]}>
        <div className={styles["receipt-header"]}>
          <h1>Rs. {formatNum(transaction?.amount ?? 0)}</h1>
          <p>
            {transaction.status?.toLowerCase() == "paid"
              ? I18n.paid_via
              : I18n.unpaid}{" "}
            <span className="textLowercase">
              {transaction.status?.toLowerCase() == "paid" ?
                transaction?.method?.toLowerCase() === "cash"
                  ? I18n.cash
                  : transaction?.method?.toLowerCase() === "online"
                    ? I18n.online
                    : I18n.bank : null}
            </span>
          </p>
        </div>
        <div className={styles["cut-shape-view"]}>
          <div className={styles["left-circle"]}></div>
          <div className={styles["dash-line-view"]}>
            {[...Array(15)].map((item, index) => {
              return <div className={styles["dash-line"]} key={index} />;
            })}
          </div>
          <div className={styles["right-circle"]}></div>
        </div>
        <table className={styles["receipt-table"]}>
          <thead>
            <tr>
              <th>{I18n.item_name}</th>
              <th>{I18n.qty}</th>
              <th style={{ textAlign: "right" }}>{I18n.amount}</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((item, index) => (
              <tr key={index}>
                <td>{item?.name ?? ""}</td>
                <td>{item?.quantity ?? "1"}</td>
                <td style={{ textAlign: "right" }}>
                  <ParagraphText className={styles.sellingPriceStyle}>
                    Rs. {formatNum(item?.selling_price || 0)}
                    {item?.discount ? (
                      <ParagraphText className={styles.discountPriceStyle}>
                        -Rs.{" "}
                        {formatNum(
                          item?.discount_method === "%"
                            ? (item?.discount * item?.selling_price) / 100
                            : item?.discount,
                        )}
                      </ParagraphText>
                    ) : (
                      ""
                    )}
                  </ParagraphText>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className={styles["receipt-summary"]}>
          <p>
            Subtotal:{" "}
            <span>
              Rs. {formatNum(transaction.sub_total || 0)}
            </span>
          </p>
          <p>
            Total Tax: <span>{transaction?._raw?.tax_rate || 0}%</span>
          </p>
          <p>
            Total Discount:{" "}
            <span>

              {`${transaction?._raw?.discount_unit !== "%" ? "Rs." : ""} ${formatNum(transaction?._raw?.discount + totalDiscountPerItem) ||
                0} ${transaction?._raw?.discount_unit == "%" ? "%" : ""}`}
            </span>
          </p>
          <h2>
            Total: <span>Rs. {formatNum(transaction.amount || 0)}</span>
          </h2>
        </div>
        <div className={styles["receipt-bottom"]}>
          <img src={receipt_bottom} />
        </div>
      </div>
    </div>
  );
});

export default Receipt;
